export default __webpack_public_path__ + "static/media/010-chocolate bar.3ec595e5.svg";